module.exports = __webpack_public_path__ + "images/services/confluence-blog-preview.ccb89f3fda423d61133d.svg";